import BillingsOrderForwardBillingsListResponse, {
  BillingsOrderForwardBillingsListResponseDataItem,
  BillingsOrderForwardBillingsListResponseDataItemBillingModel,
  BillingsOrderForwardBillingsListResponseDataItemCargoOrder,
  BillingsOrderForwardBillingsListResponseDataItemConsumer,
  BillingsOrderForwardBillingsListResponseDataItemProducer,
} from "../../../../api/raily/billings/order-forward-billings/list/billings-order-forward-billings-list.response";
import BillingModel from "../../../../types/billing-model";
import BillingsOrderForwardBillingsList, {
  BillingsOrderForwardBillingsListItem,
  BillingsOrderForwardBillingsListItemCargoOrder,
  BillingsOrderForwardBillingsListItemConsumer,
  BillingsOrderForwardBillingsListItemProducer,
} from "./billings-order-forward-billings-list";

const createDataItemCargoOrder = (
  cargoOrder: BillingsOrderForwardBillingsListResponseDataItemCargoOrder,
): BillingsOrderForwardBillingsListItemCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
  };
};

const createDataItemConsumer = (
  consumer: BillingsOrderForwardBillingsListResponseDataItemConsumer,
): BillingsOrderForwardBillingsListItemConsumer => {
  return {
    name: consumer.name,
  };
};

const createDataItemProducer = (
  producer: BillingsOrderForwardBillingsListResponseDataItemProducer,
): BillingsOrderForwardBillingsListItemProducer => {
  return {
    name: producer.name,
  };
};

const createDataItemBillingModel = (
  billingModel: BillingsOrderForwardBillingsListResponseDataItemBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderForwardBillingsListResponseDataItemBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderForwardBillingsListResponseDataItemBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderForwardBillingsListResponseDataItemBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderForwardBillingsListResponseDataItemBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItem = (
  dataItem: BillingsOrderForwardBillingsListResponseDataItem,
): BillingsOrderForwardBillingsListItem => {
  return {
    allContributionsAmount: dataItem.allContributionsAmount,
    amountForChargeHaltings: dataItem.amountForChargeHaltings,
    amountForChargeHighways: dataItem.amountForChargeHighways,
    amountForDistance: dataItem.amountForDistance,
    baseDistanceRate: dataItem.baseDistanceRate,
    billingModel: createDataItemBillingModel(dataItem.billingModel),
    cargoOrder: createDataItemCargoOrder(dataItem.cargoOrder),
    consumer: createDataItemConsumer(dataItem.consumer),
    contractName: dataItem.contractName,
    distance: dataItem.distance,
    forwardingTime: dataItem.forwardingTime,
    id: dataItem.id,
    producer: createDataItemProducer(dataItem.producer),
    startTime: dataItem.startTime,
    status: dataItem.status,
    sumOfBonuses: dataItem.sumOfBonuses,
    sumOfPenalties: dataItem.sumOfPenalties,
    route: dataItem.route ?? [],
  };
};

const createData = (
  data: BillingsOrderForwardBillingsListResponseDataItem[],
): BillingsOrderForwardBillingsListItem[] => {
  return data.map(createDataItem);
};

const create = (
  response: BillingsOrderForwardBillingsListResponse,
): BillingsOrderForwardBillingsList => {
  const data = response.data;

  return {
    data: createData(data.data),
    totalCount: data.totalCount,
  };
};

const billingsOrderForwardBillingsListFactory = {
  create,
};

export default billingsOrderForwardBillingsListFactory;
